"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareServerPayload = exports.constructPostValidateResponse = void 0;
/**
 * prepares server payload from Google pay payload along with cartAmount
 * @returns serverPayload object
 */
var prepareServerPayload = function prepareServerPayload(_ref) {
  var payloadFromGoogle = _ref.payloadFromGoogle,
    cartAmount = _ref.cartAmount,
    currencyCode = _ref.currencyCode;
  var billingInfo = prepareBillingAddressFromGooglePayload(payloadFromGoogle);
  var userInfo = prepareUserDetailsFromBillingInfo(billingInfo);
  var paymentDetails = preparePaymentDetails(payloadFromGoogle);
  var browserInfo = prepareBrowserInfoDetails();
  return {
    cartAmount: cartAmount,
    currencyCode: currencyCode,
    payment: paymentDetails,
    billingAddress: billingInfo,
    user: userInfo,
    browserInfo: browserInfo
  };
};

/**
 * @param {paymentMethodData} : paymentMethodData which has details of token and cardNetwork 
 * @returns object:  consists of Google pay payment method payload
 */
exports.prepareServerPayload = prepareServerPayload;
var preparePaymentDetails = function preparePaymentDetails(_ref2) {
  var paymentMethodData = _ref2.paymentMethodData;
  return {
    paymentMethod: 'GOOGLE_PAY',
    payload: {
      token: paymentMethodData.tokenizationData.token,
      cardType: paymentMethodData.info.cardNetwork
    }
  };
};

/**
 * 
 * @param {billingInfo}: billing address details constructed using Google Pay.
 * @returns object: consists of user details according to server payload
 */
var prepareUserDetailsFromBillingInfo = function prepareUserDetailsFromBillingInfo(billingInfo) {
  return {
    firstName: billingInfo.firstName,
    lastName: billingInfo.lastName,
    emailAddress: billingInfo.emailAddress,
    phoneNumber: billingInfo.phoneNumber
  };
};

/**
 * 
 * @param {payloadFromGoogle}: payload from goolgle pay api consists of billing info such as fullName, email, phonenumber 
 * @returns {object}: consits of billing address details according to server payload
 */
var prepareBillingAddressFromGooglePayload = function prepareBillingAddressFromGooglePayload(payloadFromGoogle) {
  var billingAddress = payloadFromGoogle.paymentMethodData.info.billingAddress;
  var email = payloadFromGoogle.email;
  var names = billingAddress.name.split(' ');
  var firstName, lastName, phoneNumber;
  if (names.length < 2) {
    firstName = billingAddress.name;
    //set lastName as Last name unknown as it's a recognised abbrevation
    lastName = 'LNU';
  } else {
    firstName = names.slice(0, -1).join(' ');
    lastName = names[names.length - 1];
  }

  //convert the phoneNumber from Google Pay to only numbers.
  phoneNumber = billingAddress.phoneNumber;
  if (phoneNumber) {
    //if first character is '+' ( +91 12345678912) then the string from first space is the original phone number. 
    phoneNumber = phoneNumber.charAt(0) == '+' ? phoneNumber.substring(phoneNumber.indexOf(' ') + 1) : phoneNumber;
    //remove all the characters except numbers
    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');
  }
  return {
    firstName: firstName,
    lastName: lastName,
    phoneNumber: phoneNumber,
    addressLine1: billingAddress.address1,
    addressLine2: billingAddress.address2 ? billingAddress.address2 : undefined,
    addressLine3: billingAddress.address3 ? billingAddress.address3 : undefined,
    city: billingAddress.locality ? billingAddress.locality : undefined,
    postalCode: billingAddress.postalCode ? billingAddress.postalCode : undefined,
    countryCode: billingAddress.countryCode ? billingAddress.countryCode : undefined,
    stateOrProvince: billingAddress.administrativeArea ? billingAddress.administrativeArea : undefined,
    emailAddress: email,
    addressType: 'BILLING'
  };
};

/**
 * 
 * @returns {object}: consists of browser info details
 */
var prepareBrowserInfoDetails = function prepareBrowserInfoDetails() {
  return {
    acceptHeader: '*/*',
    colorDepth: screen.colorDepth,
    javaEnabled: navigator.javaEnabled,
    language: navigator.language,
    screenHeight: screen.height,
    screenWidth: screen.width,
    timeZoneOffset: new Date().getTimezoneOffset(),
    userAgent: navigator.userAgent
  };
};
var constructPostValidateResponse = function constructPostValidateResponse(customFunctions, billingInfo, paymentMethod, user) {
  return customFunctions['postValidate'] ? customFunctions['postValidate']({
    'paymentData': {
      paymentMethod: paymentMethod
    },
    'otherInformation': billingInfo,
    'userInformation': user
  }) : {};
};
exports.constructPostValidateResponse = constructPostValidateResponse;